module.exports = __webpack_public_path__ + "e55f10d4baf9b13ce8c2b5d2faa11d02.svg";